// frontend/src/components/layout/AdminLayout.js
import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from '../../utils/axios';

// Import Components
import AdminNavbar from '../admin/AdminNavbar';
import AdminSidebar from '../admin/AdminSidebar';

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // ✅ JavaScript тооцоолол хасагдсан - CSS-д шийдсэн

  useEffect(() => {
    fetchUser();
  }, []);

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  const fetchUser = async () => {
    try {
      const response = await axios.get('/api/auth/me');
      
      if (response.data.success) {
        const userData = response.data.data.user;
        
        if (userData.role_name !== 'admin' && userData.role_name !== 'staff') {
          toast.warning('Та админ панел руу нэвтрэх эрхгүй байна');
          navigate('/customer/products', { replace: true });
          return;
        }
        
        setUser(userData);
      }
    } catch (error) {
      console.error('Auth check error:', error);
      toast.error('Нэвтрэх эрх шалгахад алдаа гарлаа');
      navigate('/login', { replace: true });
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post('/api/auth/logout');
      toast.success('Амжилттай гарлаа');
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Гарахад алдаа гарлаа');
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="spinner-lg mb-4"></div>
          <p className="text-gray-600">Уншиж байна...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
    <div className="admin-layout-wrapper">
      <div className="admin-layout">
        {/* Top Navbar - Fixed */}
        <AdminNavbar 
          user={user} 
          onToggleSidebar={toggleSidebar}
          onLogout={handleLogout}
        />

        {/* Sidebar - Fixed */}
        <AdminSidebar
          user={user}
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          onLogout={handleLogout}
        />

        {/* Main Content - Scrollable */}
        <main className="admin-main">
          <div className="admin-content-wrapper">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;